import { RootReducer } from '../rootReducer';

export const selectCurrentUser = (state: RootReducer) => state.user;

/** Paid access: auth settled + authenticated + a paid subscription. Single source for nav gating. */
export const selectIsPaid = (state: RootReducer): boolean =>
    Boolean(state.auth?.isComplete && state.auth?.isAuthenticated && state.user?.is_paid);

export const selectIsUserFromCalifornia = (state: RootReducer) => {
    const user = selectCurrentUser(state);

    return Boolean(user && user?.is_california);
};
